import cn from "classnames";

import { ButtonProps, Sizes, Variants } from "./Button.types";

import styles from "./Button.module.scss";

const VARIANTS: Variants = {
  primary: styles.primary,
  secondary: styles.secondary,
  accent: styles.accent,
  outline: styles.outline,
  tertiary: styles.tertiary,
  back: styles.back,
  grey: styles.grey,
  blue: styles.blue,
  black: styles.black,
  fourlife: styles.fourlife,
};

const SIZES: Sizes = {
  small: styles.small,
  medium: styles.medium,
  large: styles.large,
};

const Button = ({
  className,
  type = "button",
  variant,
  size = "medium",
  children,
  startIcon,
  endIcon,
  component = "button",
  ...restProps
}: ButtonProps) => {
  const Component = component || "button";

  const buttonProps: { type?: "button" | "submit" | "reset" } = {};

  if (component === "button") {
    buttonProps.type = type;
  }

  return (
    <Component
      {...restProps}
      {...buttonProps}
      className={cn(
        styles.button,
        {
          [styles.buttonWithIcon]: !!startIcon,
          [styles.buttonWithIcon]: !!endIcon,
        },
        VARIANTS[variant],
        SIZES[size],
        variant,
        className
      )}
    >
      {startIcon && startIcon}
      {children}
      {endIcon && endIcon}
    </Component>
  );
};

export default Button;
